import React from 'react';

function Ubisoft() {
    return <h1>
        <a href={"https://www.figma.com/file/Q7XWa2RjGpBiQ9ZLHopn6m/Assassin%27s-Creed---Strasbourg?node-id=1%3A21&t=edJWy5dh1oeJ3QbN-1"}>STRASBOURG</a>
    </h1>;
}

export default Ubisoft;